export const environment = {
  production: true,
  API_ROOT: 'https://api4.salonmonster.com/api',
  PHOTO_ROOT: 'https://salonmonster.com/userfiles/booking_pics/',
  FACEBOOK_APP_ID: '426881094074823',
  GOOGLE_MAPS_API: 'AIzaSyDWSq2r1PW_Eu3WGGLoo8a-qUBuQlQO6D8',
  stripePublishableKey: 'pk_live_X4A4x8QX3dPsmCMErLrOZ97g',
};
